import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id: mid, pagination }) => {
        const { page, pageSize: limit } = pagination;
        try {
            const [naturesRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listNatures', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listNatures', {
                    mid: mid === undefined ? [] : mid
                })
            ]);

            if (naturesRes.error || selectedRes.error) {
                throw new Error(naturesRes.msg || selectedRes.msg);
            }

            const natures = { data: naturesRes.data, count: naturesRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = natures.data.find(
                    itemNature => itemNature.mid === itemSelected.mid
                );
                if (!item) {
                    natures.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return natures;
        } catch (err) {
            console.error(err);
        }
    }
};
